var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipmentNodataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9618 1.08594V9.0713H34.9505",
    stroke: "#343434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9503 43.4083V45.4049C34.9508 45.8257 34.785 46.2297 34.4889 46.5288C34.1928 46.8279 33.7904 46.9979 33.3695 47.0017H2.57078C2.15082 46.9972 1.74973 46.8267 1.45513 46.5275C1.16053 46.2284 0.996387 45.8248 0.998564 45.405V2.69419C0.996021 2.27321 1.15969 1.86821 1.45404 1.56711C1.74839 1.26601 2.14967 1.09311 2.57078 1.08594H26.9616C27.1377 1.09039 27.3105 1.13495 27.4669 1.21621C27.6232 1.29748 27.7589 1.41332 27.8637 1.55492L34.4791 8.08031C34.6254 8.20097 34.7435 8.35225 34.8249 8.52349C34.9063 8.69473 34.9491 8.88175 34.9503 9.07134V16.9551",
    stroke: "#343434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0435 35.0234H7.97864",
    stroke: "#343434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0399 29.0352H7.97864",
    stroke: "#343434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0399 23.0469H7.97864",
    stroke: "#343434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1209 17.0586H7.97864",
    stroke: "#343434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2979 35.8702L38.6201 22.3493C38.4361 22.0261 38.1697 21.7574 37.8481 21.5705C37.5265 21.3836 37.1612 21.2852 36.7892 21.2852C36.4172 21.2852 36.0518 21.3836 35.7302 21.5705C35.4086 21.7574 35.1423 22.0261 34.9582 22.3493L27.2808 35.8702C27.0995 36.1904 27.0053 36.5525 27.0076 36.9204C27.0099 37.2884 27.1085 37.6493 27.2937 37.9672C27.4789 38.2852 27.7442 38.5491 28.0632 38.7327C28.3821 38.9163 28.7436 39.0131 29.1117 39.0136H44.4666C44.8347 39.0131 45.1962 38.9163 45.5152 38.7327C45.8342 38.5491 46.0995 38.2852 46.2847 37.9673C46.4699 37.6493 46.5686 37.2884 46.5709 36.9205C46.5732 36.5526 46.4791 36.1905 46.2979 35.8702Z",
    stroke: "#343434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7893 26.5156V32.6384",
    stroke: "#343434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7893 35.3125V35.5261",
    stroke: "#343434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentNodataIcon);
export default __webpack_public_path__ + "static/media/ShipmentNodataIcon.f462c3ba7a95a2ed5694cdcf4f5bd7b9.svg";
export { ForwardRef as ReactComponent };